import { useEffect, useMemo, useState } from "react";
import { colors } from "./config";

export const useSdgs = ({ data, activeFilter }) => {
  const [items, setItems] = useState([]);
  const [frameActions, setFrameActions] = useState(null);

  useEffect(() => {
    if (frameActions) {
      if (!data) {
        frameActions.loading(true);
      } else {
        frameActions.loading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frameActions, data]);

  useEffect(() => {
    if (data && frameActions) {
      let totalValues = 0;
      data.items.forEach((a) => totalValues += a.value[activeFilter]);
      const filteredData = data.items.filter(sdg => sdg.value[activeFilter] !== 0);

      setItems(filteredData.map((sdg) => ({
        title: sdg.title,
        percent: Number((sdg.value[activeFilter] / totalValues)),
        associatedWith: sdg.value[activeFilter],
        color: colors[sdg.title],
        label: sdg.label,
      })));

      frameActions.loading(false);

    } else if (frameActions) {
      frameActions.loading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, frameActions, activeFilter]);

  const _totalEvents = useMemo(() => {
    if (data) {
      const sum = data?.items?.reduce((all, item) => {
        const _val = item.value[activeFilter] || 0;
        return all + _val;
      }, 0);
      return sum;
    }
    return 0;
  }, [data, activeFilter]);

  return {
    items,
    _totalEvents,
    frameActions,
    setFrameActions,
  }
}
